import { combineReducers } from 'redux';
import billing from './billing';
import subscription from './subscription';
import tiers from './tiers';

export interface MarketingCratePaymentsState {
  payments: {
    billing: ReturnType<typeof billing>
    subscription: ReturnType<typeof subscription>
    tiers: ReturnType<typeof tiers>
  }
}

export default combineReducers({
  billing,
  subscription,
  tiers,
});

export * from './billing';
export * from './subscription';
export * from './tiers';
